import { render, staticRenderFns } from "./ScreenPedidos.vue?vue&type=template&id=43ac91ce"
import script from "./ScreenPedidos.vue?vue&type=script&lang=js"
export * from "./ScreenPedidos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports